// File: pages/AmplePublicationPage.jsx

import React from 'react';
import "./AmplePublicationPage.css";

import PublishingHeroSection from './PublicationSectionsComponents/PublishingHeroSection';
import TransformationSection from './PublicationSectionsComponents/TransformationSection';
import WorkWithLeadership from './PublicationSectionsComponents/WorkWithLeadership';
import ScheduleSection from './PublicationSectionsComponents/ScheduleSection';

export default function AmplePublicationPage() {

  return (

    <div className="publication-page-container">

      <PublishingHeroSection />

      <TransformationSection />

      <WorkWithLeadership />

      <ScheduleSection />

    </div>

  );
}